export default [
  {
    path: "/saldo",
    name: "balance",
    component: () => import("../views/balance/Index.vue"),
    meta: {
      template: () => import("../templates/Base.vue"),
      protected: true,
      viewContainer: true,
      breadcrumbs: ["balance"]
    }
  }
];
